
import { Column } from "primereact/column";
import Select from "react-select";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useState } from "react";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";

import * as api from "../constant/API";
import Swal from "sweetalert2";
import Utils from "../constant/Utils";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import { Link } from "react-router-dom";

const Section = () => {
    const [searchInput, setSearchInput] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [instituteId, setInstituteId] = useState("");
    const [addSecInstituteId, setAddSecInstituteId] = useState("");
    const [addSecClsId, setAddSecClsId] = useState("");
    const [editSecId, setEditSecId] = useState("");
    const [addSecName, setAddSecName] = useState("");
    const [instituteList, setInstituteList] = useState([]);
    const [classLst, setClassLst] = useState([]);
    const [section, setSection] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);

    const roleId = localStorage.getItem('RoleId');

    useEffect(() => {
        listInstitutions();
    }, []);

    function listInstitutions() {
        const instList = api.InstDd + '/' + roleId;
        setIsLoading(true);
        setTimeout(() => {
            fetch(instList, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": 'Bearer ' + Utils.getAccessToken()
                },
            })
                .then((response) => response.json())
                .then((result) => {
                    if (result.error == false) {
                        setInstituteList(result.data);
                        setIsLoading(false);
                    } else {
                        Swal.fire(result.message)
                        if (result.code == 401) {
                            Utils.logoutUser();
                        }
                    }
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                    setIsLoading(false);
                });
        }, 1000);
    }

    function listSections(insId) {
        setInstituteId(insId);
        setIsLoading(true);
        setTimeout(() => {
            const getSectionList = api.Section + '/' + insId;
            fetch(getSectionList, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": 'Bearer ' + Utils.getAccessToken()
                },
            })
                .then((response) => response.json())
                .then((result) => {
                    if (result.error == false) {
                        setSection(result.data);
                        setIsLoading(false);
                    } else {
                        Swal.fire(result.message)
                        if (result.code == 401) {
                            Utils.logoutUser();
                        }
                    }
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                    setIsLoading(false);
                })
        }, 1000);
    }

    function getclasses(ins) {
        const claslst = api.Class + '/' + ins;
        fetch(claslst, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    setClassLst(result.data)
                } else {
                    Swal.fire(result.message)
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                }
            })
    }

    function editSection(rowData) {
        const secId = rowData.sectionId;
        setEditSecId(secId);
        getclasses(instituteId)
        setIsEdit(true)
        setOpenModal(true)
        fetchdetails(secId);
    }

    function fetchdetails(secId) {
        const editSec = api.Section + '/' + instituteId + '/' + secId;
        fetch(editSec, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((response) => response.json())
            .then((result) => {
                // console.log(result.data[0].sectionClassId);

                if (result.error == false) {
                    setAddSecClsId(result.data[0].sectionClassId)
                    setAddSecName(result.data[0].sectionName)
                } else {
                    Swal.fire(result.message)
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                }
            })
    }

    function archiveSection(rowData) {
        const secId = rowData.sectionId;
        const removeSec = api.ArchieveSection + '/' + secId + '/' + instituteId;
        fetch(removeSec, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire(result.message)
                } else {
                    Swal.fire(result.message)
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                }
            })
    }

    function saveSection() {
        if (isEdit) {
            updateSection()
        } else {
            const formData = new FormData();
            formData.append("sectionInstitution", addSecInstituteId)
            formData.append("sectionClass", addSecClsId)
            formData.append("sectionName", addSecName)

            const createSection = api.SectionCreate;
            fetch(createSection, {
                method: "POST",
                headers: {
                    "Authorization": 'Bearer ' + Utils.getAccessToken()
                },
                body: formData
            })
                .then((response) => response.json())
                .then((result) => {
                    if (result.error == false) {
                        Swal.fire({
                            title: 'Success',
                            text: result.message,
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((res) => {
                            if (res.isConfirmed) {
                                window.location.reload(); // 🔁 Reload only after OK is clicked
                            }
                        });
                    } else {
                        if (result.code == 401) {
                            Utils.logoutUser();
                        }
                        Swal.fire({
                            title: 'Error',
                            text: result.message,
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((res) => {
                            if (res.isConfirmed) {
                                window.location.reload(); // 🔁 Reload only after OK is clicked
                            }
                        });
                    }
                })
        }
        setOpenModal(false)
    }

    function updateSection() {
        const formData = new FormData();
        formData.append('sectionIdEdit', editSecId);
        formData.append('sectionInstitutionEdit', instituteId)
        formData.append('sectionClassEdit', addSecClsId)
        formData.append('sectionNameEdit', addSecName)
        const sectionUpdate = api.SectionUpdate;
        fetch(sectionUpdate, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    const filteredData = section.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const classRender = (rowData) => {
        return <span>{rowData.ClassName}</span>;
    };

    const sectionRender = (rowData) => {
        return <span>{rowData.sectionName}</span>;
    };

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editSection(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const removeSection = (rowData) => {
        return (
            <Link to="#" onClick={() => archiveSection(rowData)}>
                <i className="feather-edit"></i>Remove
            </Link>
        );
    };

    return (
        <>

            {isLoading && (

                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="row">
                <div className="col-sm-12">
                    <div className="court-tab-content">
                        <div className="card card-tableset">
                            <div className="card-body">
                                <div className="coache-head-blk">
                                    <div className="row align-items-center">
                                        <div className="row col-lg-6 court-sortby sortbyset">
                                            <div className="col-lg-2" style={{ marginTop: "1.25rem" }}>
                                                <span className="sortbytitle"><h6>Institute</h6></span>
                                            </div>
                                            <div className="col-lg-10 sorting-select">
                                                {/* <Dropdown
                                                    value={instituteId}
                                                    onChange={(e) => listSections(e.target.value)}
                                                    options={instituteList}
                                                    optionLabel="institutionName"
                                                    optionValue="institutionId"
                                                    placeholder="Select an Institute"
                                                    className="select-bg w-100"
                                                /> */}
                                                <Select
                                                    value={instituteList.find(ins => ins.institutionId === instituteId) ? {
                                                        value: instituteId,
                                                        label: instituteList.find(ins => ins.institutionId === instituteId).institutionName
                                                    } : null}
                                                    onChange={(e) => {
                                                        setInstituteId(e.value)
                                                        listSections(e.value)
                                                    }}
                                                    options={instituteList.map(ins => ({
                                                        value: ins.institutionId,
                                                        label: ins.institutionName
                                                    }))}>
                                                </Select>
                                            </div>
                                        </div>
                                        {(roleId == '1' || roleId == '5') ? (
                                            <>
                                                <div className="row col-md-6">
                                                    <div className="save-changes text-sm-end">
                                                        <Button
                                                            className="btn-secondary text-uppercase"
                                                            variant="success"
                                                            onClick={() => { setOpenModal(true); setIsEdit(false) }}
                                                        >
                                                            <i className="fas fa-plus">Add Section</i>
                                                        </Button>
                                                    </div>
                                                </div>
                                            </>
                                        ) : null}
                                        <div className="col-md-12">
                                        </div>
                                        <div className="col-md-12">
                                        </div>
                                        <div className="col-md-6">
                                        </div>
                                        <div className="col-md-6">
                                            <div className="dataTables_filter">
                                                <label>
                                                    <input
                                                        type="text"
                                                        value={searchInput}
                                                        onChange={(e) => setSearchInput(e.target.value)}
                                                        placeholder="Search"
                                                        className="form-control"
                                                    />
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-content">
                                    <div
                                        className="tab-pane fade show active"
                                        id="nav-Recent"
                                        role="tabpanel"
                                        aria-labelledby="nav-Recent-tab"
                                        tabIndex={0}
                                    >
                                        <div className="table-responsive table-datatble">
                                            <DataTable
                                                className="table datatable"
                                                value={filteredData}
                                                paginator
                                                rows={10}
                                                rowsPerPageOptions={[10, 25, 50, 100]}
                                                // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                                pageLinkSize={3}
                                            >
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="slNo"
                                                    body={slNoRender}
                                                    header="Sl &nbsp; No"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="sectionName"
                                                    header="Section"
                                                    body={sectionRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="ClassName"
                                                    header="Class"
                                                    body={classRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                {(roleId == '1'|| roleId == '5') ? (
                                                    <Column
                                                        className="text-link"
                                                        body={editDetails}
                                                    ></Column>
                                                ) : null}
                                                {(roleId == '1'|| roleId == '5') ? (
                                                    <Column
                                                        className="text-link"
                                                        body={removeSection}
                                                    ></Column>
                                                ) : null}
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                openModal && (
                    <Modal
                        show={openModal}
                        size="sm"
                        centered
                    >
                        <ModalHeader>
                            <ModalTitle>
                                <h4 className="mb-0 upper-case">{isEdit ? "Edit Section" : "Add Section"}</h4>
                            </ModalTitle>
                            <Button
                                variant=""
                                className="btn-close"
                                onClick={() => setOpenModal(false)}
                            ></Button>
                        </ModalHeader>
                        <ModalBody>
                            {!isEdit &&
                                <div className="col-lg-12 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Institute</label>
                                        <Select
                                            value={instituteList.find(ins => ins.institutionId === addSecInstituteId) ? {
                                                value: addSecInstituteId,
                                                label: instituteList.find(ins => ins.institutionId === addSecInstituteId).institutionName
                                            } : null}
                                            onChange={(e) => {
                                                setAddSecInstituteId(e?.value)
                                                getclasses(e?.value)
                                            }}
                                            options={instituteList.map(ins => ({
                                                value: ins.institutionId,
                                                label: ins.institutionName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                            }
                            <div className="col-lg-12 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Class</label>
                                    <Select
                                        value={classLst.find(cls => cls.classId === addSecClsId) ? {
                                            value: addSecClsId,
                                            label: classLst.find(cls => cls.classId === addSecClsId).className
                                        } : null}
                                        onChange={(e) => {
                                            setAddSecClsId(e?.value)
                                        }}
                                        options={classLst.map(cls => ({
                                            value: cls.classId,
                                            label: cls.className
                                        }))}>
                                    </Select>
                                </div>
                            </div>

                            <div className="col-lg-12 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Section</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        id="section"
                                        value={addSecName}
                                        onChange={(e) => setAddSecName(e.target.value)}
                                        placeholder="Section Name" />
                                </div>
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                className="btn-primary text-uppercase"
                                variant="success"
                                onClick={() => { saveSection(); setOpenModal(false) }}
                                data-bs-dismiss="modal" aria-label="Close"
                            >
                                <b><i className="fas fa-save" />Save</b>
                            </Button>
                        </ModalFooter>
                    </Modal>
                )
            }
        </>
    );
};

export default Section;
